import styled from "@emotion/styled";
import { Box, Button } from "Components";
import { theme } from "Styles";

export const PanelContainer = styled.div`
    display: grid;
    grid-template-columns: 35px 1fr;
    grid-template-areas:
        "reference main"
        "reference main";
    grid-template-rows: 1fr;
    background-color: ${theme.palette.common.lightGrey};

    border: 1px solid ${theme.palette.tableHeader.main};

    @media screen and (max-width: 767px) {
        grid-template-columns: 25px 1fr;
    }
`;

export const Panel = styled.div`
    grid-area: reference;
    background-color: ${theme.palette.common.lightGrey};
    display: flex;
    justify-content: center;
    border-right: 1px solid ${theme.palette.tableHeader.main};
    padding-top: 15px;
`;

export const PanelContent = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 20px 20px;
    justify-content: center;

    label {
        text-align: center;
    }
`;

export const PanelMainContent = styled.div`
    grid-area: main;
`;

export const MobileResponsiveContainer = styled.div`
    &.isMobile {
        padding: 0px 10px;

        background-color: ${theme.palette.common.lightGrey};
    }
`;

export const Row = styled(Box)`
    display: flex;

    align-items: center;
    justify-content: space-between;
    padding: 15px 10px;
    background-color: ${theme.palette.common.lightGrey};
    border-bottom: 1px solid ${theme.palette.tableHeader.main};

    &.isMobile {
        position: relative;
        z-index: 2;
        &::after {
            content: "";
            position: absolute;
            bottom: 0;
            left: -35px;
            width: calc(100% + 35px);
            height: 1px;
        }
    }
`;

export const RowContent = styled.div``;

export const ButtonGroup = styled.div`
    display: grid;
    grid-template-columns: 30px;
`;

export const AddContainer = styled.div`
    background-color: ${theme.palette.common.lightGrey};
`;

export const AddButton = styled(Button)`
    margin-left: 10px;
    background: none;
    border: none;
    padding: 0;
    font: inherit;
    cursor: pointer;
    outline: inherit;
    display: flex;
    align-items: center;

    &:hover,
    &:focus,
    &:active {
        background-color: transparent;
    }

    label {
        cursor: pointer;
        color: ${theme.palette.common.tertiary};
        text-decoration: underline;
    }
`;
